// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2det-","right":"styles_right__2ebKA"};